import { render, staticRenderFns } from "./TripsEdit.vue?vue&type=template&id=c9ffa76a&scoped=true"
import script from "./TripsEdit.vue?vue&type=script&lang=ts"
export * from "./TripsEdit.vue?vue&type=script&lang=ts"
import style0 from "./TripsEdit.vue?vue&type=style&index=0&id=c9ffa76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ffa76a",
  null
  
)

export default component.exports